const LOGIN_EMAIL_REGEX =
  /^[a-zA-Z0-9_%+-]+(\.[a-zA-Z0-9_%+-]+)*@([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/

export const isValidLoginEmail = (value) => {
  if (value == null || typeof value !== 'string') return false
  const trimmed = value.trim()
  if (!trimmed) return false

  return LOGIN_EMAIL_REGEX.test(trimmed)
}

export const getLoginEmailError = (value, { touched } = { touched: false }) => {
  if (!touched) return ''
  const trimmed = (value || '').trim()
  if (!trimmed) return ''
  if (!isValidLoginEmail(trimmed)) {
    return 'Please enter a valid email address.'
  }

  return ''
}
